"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Stack = exports.Column = exports.Grid = exports.Container = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rebass = require("rebass");

var _Layout = require("./Layout.style");
/* eslint-disable react/destructuring-assignment */

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/prop-types */


var Container = function Container(_ref) {
  var fullwidth = _ref.fullwidth,
      props = _objectWithoutProperties(_ref, ["fullwidth"]);

  var containerSizes = {
    maxWidth: fullwidth ? '100%' : ['none', 'none', '960px', '1168px']
  };
  return /*#__PURE__*/_react.default.createElement(_rebass.Box, Object.assign({
    px: ['base', null],
    width: "100%",
    mx: "auto"
  }, containerSizes, props), props.children);
};

exports.Container = Container;

var Grid = function Grid(props) {
  return /*#__PURE__*/_react.default.createElement(_rebass.Flex, Object.assign({
    mx: [0, null, -3],
    flexWrap: "wrap"
  }, props), props.children);
};

exports.Grid = Grid;

var Column = function Column(props) {
  var order = props.order,
      inCarousel = props.inCarousel;
  var sxProps = order ? {
    order: order
  } : {};
  return /*#__PURE__*/_react.default.createElement(_Layout.StyledColumn, Object.assign({
    px: [0, null, 'medium'],
    sx: sxProps,
    height: "".concat(inCarousel ? '100%' : 'auto')
  }, props), props.children);
};

exports.Column = Column;

var Stack = function Stack(_ref2) {
  var space = _ref2.space,
      children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement(_Layout.StackWrapper, {
    space: space
  }, children);
};

exports.Stack = Stack;
Stack.propTypes = {
  space: _propTypes.default.oneOf(['none', 'xsmall', 'small', 'medium', 'base', 'large', 'xlarge', 'xxlarge', 'xxxlarge']),
  children: _propTypes.default.node.isRequired
};
Stack.defaultProps = {
  space: 'base'
};